<template>
	<div class="responsive-note">
		<h3 class="mt-12 font-weight-black">Gerar Url</h3>
		<v-card class="mt-5 d-flex align-start" width="1219" height="239">
			<div class="rounded borderGreen" style="height: 230px; width: 3px !important; background-color: var(--green); margin: 5px"></div>
			<div class="">
				<span for="Urlnumbers" class="font-weight-black pt-6 pl-9 d-flex flex-column" style="font-size: 14px">Números de Urls</span>
				<div style="background: var(--grey-day-030); height: 48px; width: 138px" class="ml-9 mt-4 rounded d-flex justify-space-around align-center">
					<div class="d-flex align-center"
						type="button"
						@click="decreaseCounter"
					>
						<img :src="model.urlsNumber === 1 ? '../../../../static/images/less-grey.svg' : '../../../../static/images/less.svg'" />
					</div>
					<input
						min="1"
						max="5"
						style="background: var(--white); height:	38px; width: 48px"
						class="rounded d-flex justify-center align-center pl-5"
						v-model="model.urlsNumber"
						v-on:input="handleNumber"
						id="Urlnumbers"/>
					<div class="d-flex align-center"
						type="button"
						@click="increaseCounter"
					>
						<img :src="model.urlsNumber === 5 ? '../../../../static/images/plus-grey.svg': '../../../../static/images/plus.svg'" />
					</div>
				</div>
				<span class="font-weight-black pt-6 pl-9 d-flex flex-column" style="font-size: 14px">Nome do teste</span>
				<span class="d-flex align-center">
					<input
						placeholder="Insira o nome do teste aqui"
						:input="handleValues"
						v-model="model.urlLong"
						class="mt-3 ml-9 mr-5 pl-2 rounded responsive-input-long" 
						style="border: 2px solid var(--grey-day-020); height: 48px; width: 917px;"
					>
					<v-btn
						width="200"
						height="48"
						class="mt-2"
						style="background: var(--red); color: var(--white)"
						@click="handleGenerate"
						:disabled="disabled"
					>
						<img :src="disabled ? '../../../../static/images/custom_grey.svg' : '../../../../static/images/custom_white.svg'"/>
						<span class="pl-3 ff">Gerar Links</span>
					</v-btn>
				</span>
			</div>
		</v-card>

		<span v-if="isurlactives">
			<v-card
				v-for="n in model.urlsToShortNumber"
				:key="n"
				class="mt-5 d-flex align-start"
				width="1219"
				height="130"
			>
				<div class="rounded borderGreen ml-1 mt-1" style="height: 120px; width: 3px !important; background-color: var(--blue); "></div>
				<div class="d-flex flex-row">
					<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url {{ n }}
						<span class="d-flex align-center">
							<input
								placeholder="Insira a URL."
								v-model="urls['url_' + n]"
								@input="handleValues"
								class="mt-3 mr-5 pl-2 rounded responsive-n" 
								style="border: 2px solid var(--grey-day-030); height: 48px; width: 700px; background: var(--grey-day-020)"
								id="Urlnumbers"
								:ref="n"
								required
							>
						</span>
					</span>
					<span class="font-weight-black pt-6 d-flex flex-column" style="font-size: 14px">Valor da importância
						<span class="d-flex align-center">
							<input
								placeholder="Ex.: 60"
								class="mt-3 mr-5 pl-2 rounded responsive-short" 
								style="border: 2px solid var(--grey-day-030); height: 48px;"
								v-model="percs['perc_' + n]"
								id="Urlnumbers"
								type="number"
								required
							>
								<!-- @input="(e) => handlePerc(e, 'perc_' + n, n)" -->
							<v-btn
								width="200"
								height="48"
								class="mt-3"
								:style="
									'background: var(--red); color: var(--white)'"
								@click="copyURL(n)"
							>
								<img src="../../../../static/images/square_white.svg"/>
								<span class="pl-3 ff">Copiar link</span>
							</v-btn>
						</span>
					</span>
				</div>
			</v-card>

			<v-btn
				class="mr-2 mt-10"
				width="120"
				height="58"
				color="var(--red)"
				style="color: var(--white)"
				@click="requestShortUrl"
				:disabled="!can_save"
			>
				Salvar
			</v-btn>
			<v-btn
				class="mt-10"
				width="120"
				height="58"
				color="var(--white)"
				@click="clearform"
			>
				Limpar
			</v-btn>
		</span>

		<v-card
			v-if="openResponseShort"
			class="mt-5 d-flex align-start"
			width="1219"
			height="130"
		>
			<div class="rounded borderGreen ml-1 mt-1" style="height: 120px; width: 3px !important; background-color: var(--blue);"></div>
			<div class="d-flex align-center">
				<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url Curta
					<span class="d-flex align-center">
						<input
							v-model="shorterUrl"
							v-on:focus="$event.target.select()"
							ref="copie"
							class="mt-3 mr-5 pl-2 rounded responsive-input-long" 
							style="border: 2px solid var(--grey-day-030); height: 48px; width: 917px; background: var(--grey-day-020)"
						>
					</span>
				</span>
				<span class="d-flex align-center mt-10">
					<v-btn
						width="200"
						height="48"
						class="mt-3"
						:style="
							url !== '' ? 'background: var(--red); color: var(--white)' : 'background: var(--white); color: var(--black)'"
						@click="copy"
					>
						<img src="../../../../static/images/square_white.svg"/>
						<span class="pl-3 ff">Copiar</span>
					</v-btn>
				</span>
			</div>
		</v-card>

		<v-snackbar 
      v-model="copyView"
      :timeout="3000"
			color="success"
			top
    >
      Url	copiada
    </v-snackbar>
			
		<div style="height:100px"></div>
	</div>
</template>
<script>
// Lib
import { mapState, mapActions, mapMutations } from 'vuex'

import VueCookies from 'vue-cookies'

//mixins
import SplitTest from '../../../mixins/splitTest'

export default {
	mixins: [SplitTest],
	data () {
		return {
			copyView: false,
			generatorNumber: 1,
			cards: 0,
			copyText: 'Copiar',
			shorterUrl: '',
			isurlactives: false,
			createdUrl: '',
			model: {
        urlsNumber: 1,
        urlsToShortNumber: 1,
      },
			urlLong: '',
			urls: {
        url_1: '',
        url_2: '',
        url_3: '',
        url_4: '',
        url_5: '',
      },
			percs: {
        perc_1: '',
        perc_2: '',
        perc_3: '',
        perc_4: '',
        perc_5: '',
      },
			openResponseShort: false,
			disabled: true,
			can_save: false,
			isEmptyUrl: null
		}
	},
	computed: {
		...mapState('SplitTest', {
			url: 'url',
		}),
	},
	methods: {
		...mapActions('SplitTest',{
			createShorttUrl: 'createShorttUrl'
		}),
		...mapMutations('Shared', {
			setToaster: 'SET_TOASTER'
		}),
		handleValues() {
      let perc_keys = Object.keys(this.percs);
      let urls_keys = Object.keys(this.urls);
      let urlNumber = this.model.urlsToShortNumber;
      let hasurlempty = urls_keys.some(
        (value, index) => !this.urls[value] && index <= urlNumber - 1
      );
      let haspercsempty = perc_keys.some(
				(value, index) => !this.percs[value] && index <= urlNumber - 1
      );
      if (!this.model.urlLong) return (this.can_save = false);
      this.model.urlLong = this.model.urlLong.replace(/[^\w\s]/gi, '')

      if (hasurlempty) return (this.can_save = false);
      if (haspercsempty) return (this.can_save = false);
      if (
				perc_keys &&
        perc_keys
          .map((v) => this.percs[v])
					.filter(n => Number(n))
          .reduce((a, b) => Number(a) + Number(b)) !== 100
      )
        return (this.can_save = false);
			
      return this.can_save = true
    },
		async requestShortUrl () {
			this.openResponseShort = false
			const token = VueCookies.get('jwt-login')
			let percs = Object.values(this.percs);

			let data = Object.keys(this.urls)
				.filter((item) => this.urls[item])
				.map((item, index) => ({
					url: this.urls[item],
					percentage: percs[index],
				}));
				
			let dados = {
				test_name: this.model.urlLong,
				urls: data,
			};

			try {
				await this.createShorttUrl([
					{
						dados
					},
					token
				])
				this.shorterUrl = this.url.body.shortUrl
				if (!this.can_save) {
					this.toaster(
							'Não é possível criar um teste com a Url em branco',
							'var(--red)',
							true
						)
					} else {
						this.isurlactives = false
						this.openResponseShort = true
						this.generatorNumber = 1
						this.urlLong = ''
						this.toaster(
							'O teste foi criado com sucesso',
							'var(--green)',
							true
						)
					}
			} catch (e) {
				this.openResponseShort = false
        this.toaster(
					'Não é possível criar um teste com a Url em branco',
					'var(--red)',
					true
				)
      }
		},
		clearform () {
			this.urls = {
        url_1: "",
        url_2: "",
        url_3: "",
        url_4: "",
        url_5: "",
      };
      this.percs = {
        perc_1: "",
        perc_2: "",
        perc_3: "",
        perc_4: "",
        perc_5: "",
      };
		},
		copy () {
      this.$refs.copie.focus()

      document.execCommand('copy')
    },
		async copyURL (n) {
			// let cop = ['url_' + n][0].value
      this.$refs[n][0].value
      document.execCommand('copy')
			await navigator.clipboard.writeText(this.$refs[n][0].value);
      this.copyView = true
    },
		toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
	},
}
</script>
<style lang="" scoped>
.responsive-short {
	width: 200px
}
@media screen and (max-width: 1377px) {
	.responsive-note {
		width: 817px
	}
	
	.borderGreen {
		padding-left: 4px;	
	}
	.responsive-input-long {
		width: 517px !important;
	}
	.responsive-n {
		width: 320px !important;
	}
	.responsive-input-short {
		width: 575px !important;
	}
	.responsive-short {
		width: 180px
	}
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/SplitTest/GeneratorUrl.vue